import React, { useEffect, useState } from 'react'
import { instance,currentDate } from './common';
import parse from "html-react-parser";

function LastSection_ab({ history }){
    const [noticeData, setNoticeData] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [faqData, setFaqData] = useState([]);

    useEffect(() => {
        let noticeObj = {
            ppp: 10,
            page: 1,
            keyword: '',
            value: ''
        };
        let eventObj = {
            page: 1,
            ppp: 6,
            value: 'e_title',
            keyword: '' 
        };

        instance.post('/notice/all', noticeObj).then(function (res) {
            setNoticeData(res.data.rows);
        });
        instance.post("/event/e_select", eventObj).then(function (res) {
            setEventData(res.data);
        });
        instance.post("/faq/all/list").then(function (res) {
            const slicedData = res.data.rows.slice(0, 3);
            setFaqData(slicedData);
        });
    }, []);

    const goNoticeLink = (id) => {
        if (id !== undefined) 
            history.push('/noticedetail?n_id='+id);
        else 
            history.push('/noticelist');
    };

    const goEventLink = (id) => {
        if (id !== undefined) 
            history.push('/eventdetail?e_seq='+id);
        else 
            history.push('/event');
    }

    const goFaqLink = () => {
        history.push('/faqlist'); 
    }

    
    const cursorPointer = {
        cursor: 'pointer',
    }

    return (
        
        <div className="container abys_board_wrap">
        <div className="row p-0">
            <div className="col-6">
                <div className="mb-5">
                    {/* <div className="abys_board_title mb-4">공지 및 소식<div className="titleplus gongjiplus" onClick={() => goNoticeLink()}>+</div></div> */}
                    <div className="abys_board_title mb-4">공지 및 소식</div>
                    <ul className="list-group">
                        {
                            noticeData.map((v,i) => 
                            <li className="list-group-item abys_board_list pl-1" onClick={() => goNoticeLink(v.n_id)} style={cursorPointer}>
                                <span className="abys_board_date" >{v.n_date}</span>
                                <span>{v.n_title}</span>
                            </li>)
                        }
                    </ul>
                </div>
            </div>
            <div className="col-6">
                <div className="mb-5">
                    <div className="abys_board_title mb-4">이벤트</div>
                    {/* <div className="abys_board_title mb-4">이벤트<div className="titleplus eventplus" onClick={() => goEventLink()}>+</div></div> */}
                    
                    {
                        eventData.map(v => 
                            <div className="abys_event_wrap" onClick={() => goEventLink(v.e_seq)} style={cursorPointer}> 
                                <p className="event-text d-inline-block mr-2">{v.e_title}</p> 
                                {
                                    v.e_date === currentDate()
                                    && <span className="d-inline-block" style={{fontSize:'12px',color:'#fff',backgroundColor:'#2F79D9',padding:'1px 4px'}}>New</span>
                                } 
                                
                            </div>
                        )
                    }
                </div>
                <div>
                    <div className="abys_board_title mb-4">자주하는 질문</div>
                    {/* <div className="abys_board_title mb-4">자주하는 질문<div className="titleplus jilmoonplus" onClick={goFaqLink}>+</div></div> */}
                    <div className="abys_qna_wrap">
                        {
                            faqData.map((v) => 
                                <div className="abys_qna_list bg-light pl-4 mb-4" onClick={goFaqLink} style={cursorPointer}>
                                    <div className="abys_qna_list_text text-dark"><span className="qna_q">Q</span>{v.title}</div>
                                </div>)
                        }
                    </div>
                </div>
            </div>
            
        </div>
    </div>
        
        
    )
}

export default LastSection_ab